import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--cream)] py-24 md:py-32" data-id="element-186">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto px-6" data-id="element-187">
        <div className="bg-white p-12 rounded-2xl border-2 border-[var(--warm-gold)] shadow-lg" data-id="element-188">
          <div className="flex flex-col items-center text-center space-y-6" data-id="element-189">
            <div className="w-20 h-20 bg-[var(--warm-gold)] rounded-full flex items-center justify-center" data-id="element-190">
              <Shield className="w-10 h-10 text-[var(--midnight)]" data-id="element-191" />
            </div>

            <h2 className="font-display text-3xl md:text-4xl text-[var(--dusk-purple)]" data-id="element-192">
              Tu Garantía
            </h2>

            <div className="space-y-4 text-lg text-[var(--charcoal)] leading-relaxed" data-id="element-193">
              <p data-id="element-194">Este libro no hace promesas vacías.</p>

              <p className="font-semibold text-xl text-[var(--dusk-purple)]" data-id="element-195">
                Te pide que entres en tu verdad — y a cambio, te entrega un
                proceso probado.
              </p>

              <p data-id="element-196">
                Si lees los primeros tres capítulos y sientes que esto no es lo
                que necesitabas, no habrás perdido nada. Porque incluso esas
                primeras páginas te van a decir algo que necesitabas escuchar.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}